import { Typography } from '@mui/material';

import Grid from 'components/core/Grid';
import { PRODUCTION_DOMAIN } from 'config/appconstants';

import { checkoutRefer, facebookIcon } from 'config/imageUrls';

export const GiveEarnCreditsTemp = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} mb={2}>
        <Typography variant="h6">Booking on alluraDirect Saves you Money!</Typography>
      </Grid>

      <Grid item xs={12} sm={4} align="center">
        <img src={checkoutRefer} className="img-responsive" height={150} />
      </Grid>

      <Grid item xs={12} sm={8}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body1">
              Did you know that by booking with alluraDirect, you can save up to 50% off service fees for the exact same
              property on other hosting websites?
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1">
              Help us by letting your friends know about alluraDirect. Same properties, less service fees.
            </Typography>
          </Grid>
          <Grid item xs={12} align="center" mt={1}>
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=https%3A//${PRODUCTION_DOMAIN}`}
              target="_blank"
              rel="noreferrer"
            >
              <img src={facebookIcon} width="140px" />
            </a>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} mb={3}></Grid>
    </Grid>
  );
};
